import type { CustomerLotDocument } from "../api/lotDocuments";

/** Vrsta dokumenta o kvalitetu, napisana rečima koje kupac i traži. */
export function nazivVrsteDokumenta(
  kind: CustomerLotDocument["kind"],
  t: (k: string, d: string) => string,
): string {
  if (kind === "COA") return t("lotDoc.kind.COA", "Sertifikat analize");
  if (kind === "NON_GMO") return t("lotDoc.kind.NON_GMO", "Izjava o NON GMO statusu");
  if (kind === "HEALTH_CERTIFICATE") return t("lotDoc.kind.HEALTH_CERTIFICATE", "Zdravstveni sertifikat");
  return t("lotDoc.kind.OTHER", "Drugo");
}
